import React from 'react';
import TaxSingoScheduledList from './TaxSingoScheduledList';
import TaxSingoTaxpayerSingoList from './TaxSingoTaxpayerSingoList';

const TaxConsulting = (props) => {
  const searchParams = new URLSearchParams(props.location.search);
  const scheduledIdx = searchParams.get('scheduledIdx');

  return scheduledIdx ?
    <TaxSingoTaxpayerSingoList
      {...props}
      scheduledIdx={Number(scheduledIdx) || null}
    />
    :
    <TaxSingoScheduledList
      {...props}
    />;
};

export default TaxConsulting;